import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedMeasurementReports = {
    id: 1,
    plotId: 1,
    timestamp: '1600552800',
    userId: 1,
    type: 'irrigation',
    value: 12
};
export const mockedEditMeasurementReports = {
    id: 1,
    plotId: 1,
    timestamp: '1600552800',
    userId: 1,
    type: 'irrigation',
    value: 12
};
export const mockedMeasurementReportCumulativeSum = {
    cumul: 51,
    count: 10
};
const response = mockedPaginatedResponse([mockedMeasurementReports]);
const mock = {
    create: mockedRequester(mockedEditMeasurementReports, 'measurementsReports.create'),
    delete: mockedRequester(undefined, 'measurementsReports.delete'),
    get: mockedRequester(mockedMeasurementReports, 'measurementsReports.get'),
    getCumulativeSum: mockedRequester(mockedMeasurementReportCumulativeSum, 'measurementsReports.getCumulativeSum'),
    getAllPages: mockedRequester([mockedMeasurementReports], 'measurementsReports.getAllPages'),
    getMany: mockedRequester(response, 'measurementsReports.getMany'),
    getPage: mockedRequester(response, 'measurementsReports.getPage'),
    update: mockedRequester(mockedEditMeasurementReports, 'measurementsReports.update')
};
export default mock;
